<template>

<app-wrapper>

	<app-text>

        <app-group v-html="page.business_adverts_book_success_content" />

        <app-group :row="true" :center="true">

            <app-button :text="page.business_adverts_book_success_button_back" theme="blue" v-on:click="$emit('back')" />

        </app-group>

    </app-text>

</app-wrapper>

</template>

<script>

export default {

}

</script>